import React from 'react'
import { MenuItemModel } from '../../../Controllers/Menu/MenuItemModel';
import { AuthItem } from '../AuthItem';
import { ImageView } from '../ImageView';
import { LangItem } from '../LangItem';

type menuItemProps = {
    selected?: boolean
    component?: MenuItemModel
}

type menuItemState = {
    selected: boolean
}

class MenuItem extends React.Component {
    props: menuItemProps
    state: menuItemState;
    constructor(props:menuItemProps){
        super(props)
        this.props = props
        this.state = {
            selected: props.selected || false
        }
        // this.handleClick = this.handleClick.bind(this)
        this.setSelected = this.setSelected.bind(this)
    }

    setSelected(bool: boolean){
        this.setState({
            selected: bool
        })
    }
    render(){
        const {component} = this.props
        const {selected} = this.state
        const Child =  <div className={`menu-item ${selected && "menu-item-selected"}`} onClick={component?.click}>
            <div className="menu-item-conteiner">
                {component?.new && <div className="new-tag"/>}
                {component?.icon && <div className="menu-item-icon">
                    <ImageView source={component?.icon} />
                </div>}
                <div className="menu-item-title">
                    <LangItem for={component?.title||""} c/>
                </div>
            </div>
        </div>

        return component?.authItem ? <AuthItem>{Child}</AuthItem>: Child
    }
}

export { MenuItem }